import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=43dfc54a&"
import script from "./AppError.vue?vue&type=script&lang=ts&"
export * from "./AppError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports